if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
       const formPropNew = this.submitButton.getAttribute('utm-data');
      if (formPropNew != null) {
        formData.append('properties[utm_source]',formPropNew);
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
           if (document.body.classList.contains('template-product-kefineproduct')) {
              addItemsToCart();
          } else {
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
           document.body.classList.add('overflow-cart-hidden');
            startTimer();
        });
           }      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// kombucha ADD TO CART components
if (!customElements.get('kombucha-product-form')) {
  customElements.define('kombucha-product-form', class ProductFormKombucha extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return; 
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      const quantityInputs = document.querySelectorAll(".quantity__input-cstm-kombucha");
      if (!quantityInputs.length) {
        this.handleErrorMessage("No quantities found. Please try again.");
        return;
      }
      const quantities = Array.from(quantityInputs).map(input => ({
        id: input.id || null,
        value: parseInt(input.value, 10) || 0,
        dataId: input.getAttribute('data-id') || null
      }));

      const finalTotal = quantities.reduce((total, item) => total + item.value, 0);
      console.log("Final Total Value:", finalTotal);
      const restriction = this.classList.contains('kimchi-form') ? 1 : 6;
       const randomValue = Math.floor(Math.random() * 10);
      const getRemainingQuantity = (total) => {
       const nextMultipleOfSix = Math.ceil(total / restriction) * restriction;
        return nextMultipleOfSix - total;
      };
    const productName = restriction === 6 ? 'Kombucha' : 'Kimchi';
      if (finalTotal < restriction) {
        const remainingQuantity = getRemainingQuantity(finalTotal);
        this.handleErrorMessage(`Please add ${remainingQuantity} more to complete a set of ${restriction} Bottles. ${productName} can be ordered only in multiples of ${restriction}s.`);
        return;
      } else if (finalTotal % restriction !== 0) {
        const remainingQuantity = getRemainingQuantity(finalTotal);
        const mainQty = finalTotal + remainingQuantity;
        this.handleErrorMessage(`Please add ${remainingQuantity} more to complete a set of ${mainQty} Bottles. ${productName} can be ordered only in multiples of ${restriction}s.`);
        return;
      }
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = {
        items: [],
        sections: this.cart ? this.cart.getSectionsToRender()?.map(section => section.id) : []
      };
      
      quantities.forEach(item => {
              if (item.dataId && item.value > 0) {
                formData.items.push({
                  id: item.dataId,
                  quantity: item.value,
                    properties: {
                    count: "kombucha-bundle" + randomValue
                  }
                });
              }
            });
      formData.items.forEach((item, index) => {
    console.log(`Item ${index + 1} Properties:`, item.properties);
  });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error("Error submitting cart form:", e);
          this.handleErrorMessage("An error occurred. Please try again.");
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
          document.body.classList.add('overflow-cart-hidden');
          startTimer(); 
        });
    }
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      if (!this.errorMessage) return;

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


  function startTimer() {
    const now = new Date();
    const currentTime = now.getTime();
    const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0).getTime();

    if (currentTime > targetTime) {
      document.querySelector('.Cart_Time').style.display = "none";
      var timeIn = document.querySelector('.variant-pop-box .countdown-on');
     if (timeIn) { 
      document.querySelector('.variant-pop-box .countdown-on').style.display = "none";
     }
      return;
    }

    let secondsLeft = Math.floor((targetTime - currentTime) / 1000);

    function timer() {
      const hours = Math.floor(secondsLeft / 3600);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      if (secondsLeft <= 0) {
        document.querySelector('.Cart_Time').style.display = "none";
         if (timeIn) { 
      document.querySelector('.variant-pop-box .countdown-on').style.display = "none";
     }
        clearInterval(timerInterval);
        return;
      }

      document.querySelectorAll(".countdown-text").forEach((element) => {
        element.innerHTML = (hours < 10 ? "0" : "") + hours + ": " + 
                            (minutes < 10 ? "0" : "") + minutes + ": " + 
                            (seconds < 10 ? "0" : "") + seconds + " hours!";
      });

      secondsLeft--;
    }

    timer();
    const timerInterval = setInterval(timer, 1000);
  }
window.addItemsToCart = function(ctaElement) {
    const miniCart = document.querySelector("cart-drawer");
    const variantBoxes = document.querySelectorAll('.variant-box-int');
    const productForm = document.querySelector('.product-form');  
    console.log('productForm', productForm);
    const formData = {
        items: [],
        sections: miniCart.getSectionsToRender().map((section) => section.id)
    };
    variantBoxes.forEach(function(variantBox) {
        const variantId = variantBox.getAttribute('data-id');
        const quantityInput = variantBox.querySelector('.quantity__input-cstm');
        const quantityValue = quantityInput ? parseInt(quantityInput.value) : null;       
        if (variantId && quantityValue !== null && quantityValue > 0) {
            const productVariantId = productForm.querySelector('input[name="id"]').value;
            console.log('productVariantId', productVariantId);
               formData.items.push({
                    id: variantId,
                    quantity: quantityValue 
                });
        }
    });
    console.log('Form Data being sent:', JSON.stringify(formData));
    if (formData.items.length === 0) {
        console.log('No valid items to add to the cart.');
        return;
    }
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then((response) => {
        return response.json().then((resp) => {
            console.log('Response JSON:', resp);
            if (resp.items && resp.items.length !== formData.items.length) {
                console.error('Mismatch in items count:', resp.items.length, formData.items.length);
            }
            miniCart.renderContents(resp);
            miniCart.classList.remove('is-empty');
            document.querySelector('body').classList.remove('no-scroll');
        });
    })
    .catch((error) => {
        console.error('Error adding to cart:', error);
    })
   .finally(() => {
           const submitButton = document.querySelector('.product-form__submit');
        const cart = document.querySelector('cart-drawer');
             const loadingSpinner = submitButton.querySelector('.loading-overlay__spinner');
        if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
        }
        if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
        }
        if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
        }
        document.body.classList.add('overflow-cart-hidden');
        startTimer();
   });
};